import { useContext, useEffect, useState } from "react";
import { MyContext } from "../MyContext";
import { 
    FormControl, Box, Grid, TextField, Button, InputLabel, Select, MenuItem
} from "@mui/material";
import helpers from "../Helpers";
import axios from "axios";
import logo from '../images/logo.png';

function Login(){
    const { setAuth, setIsAuthenticated } = useContext(MyContext);
    const [urlApi, setUrlApi] = useState(process.env.REACT_APP_URL_API);
    const [selectAlmoxarifados, setSelectAlmoxarifados] = useState([]);
    const [tpEmpresa, setTpEmpresa] = useState(null);
    const [dsAlmoxarifado, setDsAlmoxarifado] = useState(null);
    const [userLogin, setUserLogin] = useState({
        email: '',
        senha: (tpEmpresa === 'Q') ? '' : '12345678',
        id_almoxarifado: 0
    });

    const getInfoEmpresa = async() => {
        let alertForm = {};

        try {
            const rota = `${urlApi}/info_empresa`;
            const resp = await axios.get(rota);
            const data = resp.data;
            
            setTpEmpresa(data.tp_modelonf);
            setSelectAlmoxarifados(data.estoques);
            localStorage.setItem('infoEmpresa', data.tp_modelonf);
        } catch (error) {
            alertForm = {
                title: `Falhou !!! ${error.message}`,
                icon: 'error',
            };
            return helpers.toastAlert(alertForm);
        }
    };

    const initLogin = () => {
        const user = localStorage.getItem('user');

        if(user){
            setUserLogin((prev) => ({...prev, email: user}));
        }
    };

    const handleSelectAlmoxarifado = (e) => {
        const value = e.target.value;
        const selected = selectAlmoxarifados.find(item => item.id === value);

        setDsAlmoxarifado(selected?.ds_almoxarifado);
        setUserLogin((prev)=>({ ...prev, id_almoxarifado: value }));
    };

    const handleSubmitLogin = async(e) => {
        e.preventDefault();

        if(userLogin.email === ''){
            helpers.toastAlert({
                title: "Informe o login do usuário",
                icon: 'warning',
            }, 3000);
            return;
        }

        if(tpEmpresa === 'Q'){
            if(userLogin.senha === ''){
                helpers.toastAlert({
                    title: "Informe a senha do usuário",
                    icon: 'warning',
                }, 3000);
                return;
            }

            if(userLogin.id_almoxarifado == 0){
                helpers.toastAlert({
                    title: "Informe o depósito",
                    icon: 'warning',
                }, 3000);
                return;
            }
        }

        const base_url = `${urlApi}/login2`;

        try {
            let response = await axios.post(base_url, userLogin, {
                headers: { 
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });

            let data = response.data;

            if (data.status && data.status !== 200) {
                return helpers.toastAlert({
                    title: `Falhou! ${data.user.message}`,
                    icon: 'error',
                }, 3000);
            }

            if(data.user?.ativo !== 'L'){
                return helpers.toastAlert({
                    title: `Falhou! ${data.user.message}`,
                    icon: 'error',
                }, 3000);
            }

            localStorage.clear();
            localStorage.setItem('logged', 'true');
            localStorage.setItem('userAuth', JSON.stringify(data.user));
            localStorage.setItem('infoEmpresa', tpEmpresa);
            localStorage.setItem('idAlmoxarifado', userLogin.id_almoxarifado);
            localStorage.setItem('dsAlmoxarifado', dsAlmoxarifado);

            setIsAuthenticated(true);
        } catch (error) {
            console.error('Erro na requisição de login:', error);

            setAuth(null);
        }
    };

    useEffect(()=>{
        getInfoEmpresa();
        initLogin();
    }, []);

    return (
        <>
            <Box 
                component="section"
                sx={{ 
                    bgcolor: '#f5f5f5', 
                    width: 320,
                    maxHeight: 340,
                    height: '100%',
                    margin: '10% auto',
                    padding: '0 3%',
                }} 
            >
                <Box component="section" sx={{ width: '100%', height: 120, }} >
                    <img src={logo} alt={'Advanced Vendas'} loading="lazy" style={{ width: '100%', height: '100%' }}/>
                </Box>
                <Box component="section" sx={{ width: '100%', height: 340, }} >
                    <form 
                        style={{ 
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >

                        {/* <h3 style={{ fontSize: 24, fontWeight: 'bold', marginBottom: 20, textAlign: 'center' }}>
                            LOGIN
                        </h3> */}

                        <Grid container rowSpacing={2}>

                            <Grid size={12}>
                                <TextField 
                                    id="outlined-basic" 
                                    label="Login usuário" 
                                    size="small"
                                    value={userLogin.email} 
                                    onChange={(e) => setUserLogin((prev) => ({...prev, email: e.target.value.slice(0,100)}))}
                                    variant="outlined"
                                    fullWidth
                                />
                            </Grid>

                            {
                                (tpEmpresa === 'Q') &&   
                                <>
                                    <Grid size={12}>
                                        <TextField 
                                            id="outlined-basic" 
                                            label="Senha" 
                                            size="small"
                                            variant="outlined" 
                                            onChange={(e) => setUserLogin((prev) => ({...prev, senha: e.target.value.slice(0,60)}))}
                                            type="password"
                                            autoComplete="new-password"
                                            fullWidth
                                        />
                                    </Grid>

                                    <Grid size={12}>
                                        <FormControl fullWidth sx={{ borderRadius: 5, backgroundColor: '#f5f5f5' }}>
                                            <InputLabel id="idAlmoxarifado">Depósito</InputLabel>
                                            <Select
                                                labelId="idAlmoxarifado"
                                                id="idAlmoxarifado"
                                                label="Depósito"
                                                size="small"
                                                defaultValue={userLogin.id_almoxarifado}
                                                onChange={(e)=>handleSelectAlmoxarifado(e)}
                                                sx={{ backgroundColor: '#fff' }}
                                            >
                                                <MenuItem value={0} disabled>Selecione uma opção</MenuItem>
                                                {
                                                    (selectAlmoxarifados.length > 0) &&
                                                    selectAlmoxarifados.map((item, index)=>{
                                                        return <MenuItem value={item.id}>{item.ds_almoxarifado}</MenuItem>;
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </>
                            }

                            <Button 
                                component={'button'} 
                                onClick={handleSubmitLogin} 
                                variant="contained" 
                                size="large" 
                                fullWidth 
                                sx={{ 
                                    marginBottom: 0 
                                }}
                            > 
                                Entrar
                            </Button>

                        </Grid>
                    </form>
                </Box>
            </Box>
        </>
    );
}

export default Login;